import BaseInputTags from "./BaseInputTags.vue";

export * from "./BaseInputTags.vue";
export default BaseInputTags;
